import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import { ref } from "vue";
import Input from "@/components/Input.vue";
import Button from "@/components/Button.vue";

const minWidth = 90;

// eslint-disable-next-line

export default /*@__PURE__*/_defineComponent({
  __name: 'CustomForm',
  setup(__props) {

const input = ref("");
const date = ref("");
const time = ref("");

const onClick = () => console.log("qwe");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Input, {
      label: "Имя",
      modelValue: input.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((input).value = $event)),
      "error-text": "Обязательное поле",
      validator: (value) => value.length > 0,
      "min-label-width": minWidth,
      placeholder: "placeholder"
    }, null, 8, ["modelValue", "validator"]),
    _createVNode(Input, {
      type: "date",
      label: "Дата рождения",
      modelValue: date.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((date).value = $event)),
      "error-text": "error",
      validator: () => false,
      "min-label-width": minWidth
    }, null, 8, ["modelValue"]),
    _createVNode(Input, {
      type: "time",
      label: "Время рождения",
      modelValue: time.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((time).value = $event)),
      "error-text": "error",
      validator: () => false,
      "min-label-width": minWidth
    }, null, 8, ["modelValue"]),
    _createVNode(Input, {
      label: "Область",
      modelValue: input.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((input).value = $event)),
      "error-text": "Обязательное поле",
      validator: (v) => v.length > 3,
      "min-label-width": minWidth
    }, null, 8, ["modelValue", "validator"]),
    _createVNode(Input, {
      label: "Город",
      caption: "Название населенного пункта",
      modelValue: input.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((input).value = $event)),
      "error-text": "Обязательное поле",
      validator: (v) => v.length > 3,
      "min-label-width": minWidth
    }, null, 8, ["modelValue", "validator"]),
    _createVNode(Button, {
      label: "Enabled",
      onClick: onClick
    }),
    _createVNode(Button, {
      label: "Disabled",
      disabled: "",
      onClick: onClick
    })
  ]))
}
}

})